import React from 'react';
import Leadership from '../components/Leadership';

const LeadershipPage = () => {
  return <Leadership />;
};

export default LeadershipPage; 